<template>
  <v-app-bar
    app
    color="blue-grey darken-2"
    dark
  >
    <div class="d-flex align-center">
      <router-link to="/home">
        <v-img
          alt="Logo Talento"
          class="nv-logo"
          :src="require('@/assets/img/talento_1.png')"
        />  
      </router-link>
    </div>
    <v-spacer></v-spacer>
    <v-btn v-if="flag" to="/admin" text>
      <span class="mr-2">Admin</span>
    </v-btn>
    <v-btn v-if="!flag" to="/login" text>
      <span class="mr-2">Login</span>
      <v-icon>mdi mdi-login</v-icon>
    </v-btn>
    <v-btn v-else @click="logout()" text>
      <span class="mr-2">Logout</span>
      <v-icon>mdi mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>  
</template>
<script>
  import firebase from 'firebase'
  export default {
    name: 'Header',
    data(){
      return{
        flag: null
      }
    },
    methods:{
      logout(){
        firebase.auth().signOut()
        .then(()=> this.$router.replace('login'))
      }
    },
    created(){
      this.flag = firebase.auth().currentUser
    }
  }
</script>
